import { render, staticRenderFns } from "./EatselfPagination.vue?vue&type=template&id=54c9eada"
import script from "./EatselfPagination.vue?vue&type=script&lang=ts"
export * from "./EatselfPagination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c9eada')) {
      api.createRecord('54c9eada', component.options)
    } else {
      api.reload('54c9eada', component.options)
    }
    module.hot.accept("./EatselfPagination.vue?vue&type=template&id=54c9eada", function () {
      api.rerender('54c9eada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/EatselfPagination.vue"
export default component.exports